import React from 'react';

import { useTicketAuditContext } from '../startup/TicketAuditApp';
import PageFrame from '../../ProfitAndLoss/components/PageFrame';
import TicketAuditTables from './TicketAuditTables';

const TicketAudit = () => {
  const {
    csrfToken,
    team,
    confirm,
    currentUser,
    showPageFrame,
    eventDetails,
    ticketTypes,
    ticketTypesTotalAvailable,
    ticketTypesTotalHeld,
    ticketTypesTotalSold,
    ticketTypesTotalComp,
    ticketTypesTotalSubTotal,
    salesBySource,
    salesBySourceTotal,
    salesByPaymentMethod,
    salesByPaymentMethodTotal,
    generatedAt,
  } = useTicketAuditContext();

  const downloadLinks = [
    {
      href: `/teams/${team.id}/confirms/${confirm.id}/ticket_audit.pdf`,
      icon: "far fa-file-pdf",
      label: "Download PDF"
    }
  ];

  return (
    <PageFrame
      csrfToken={csrfToken}
      currentUser={currentUser}
      confirm={confirm}
      showPageFrame={showPageFrame}
      team={team}
      downloadLinks={downloadLinks}
    >
      <TicketAuditTables
        eventDetails={eventDetails}
        ticketTypes={ticketTypes}
        ticketTypesTotalAvailable={ticketTypesTotalAvailable}
        ticketTypesTotalHeld={ticketTypesTotalHeld}
        ticketTypesTotalSold={ticketTypesTotalSold}
        ticketTypesTotalComp={ticketTypesTotalComp}
        ticketTypesTotalSubTotal={ticketTypesTotalSubTotal}
        salesBySource={salesBySource}
        salesBySourceTotal={salesBySourceTotal}
        salesByPaymentMethod={salesByPaymentMethod}
        salesByPaymentMethodTotal={salesByPaymentMethodTotal}
        generatedAt={generatedAt}
      />
    </PageFrame>
  );
};

export default TicketAudit;
